import {Component, OnInit, ViewChild, ElementRef, ViewContainerRef} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import {StripeService, StripeCardComponent, ElementOptions, ElementsOptions} from "ngx-stripe";
import {ActivatedRoute, Router} from "@angular/router";
import {Overlay} from "angular2-modal";
import {Modal} from "angular2-modal/plugins/bootstrap";
import {Restaurant} from "../../shared/model/restaurant";
import {RestaurantService} from "../../shared/services/restaurant/restaurant.service";
import {validateEmail} from "../../shared/validators/validate-email";
import {LocalStripeService} from "../../shared/services/stripe/local.stripe.service";


@Component({
  selector: 'app-credit-card-create',
  templateUrl: './credit-card-create.component.html',
  styleUrls: ['./credit-card-create.component.css']
})
export class CreditCardCreateComponent implements OnInit {


   restaurant:Restaurant;
   buy:any;
  private customer_id:string;
   showCreditCardError:boolean;
  private ccerror:string;


  @ViewChild(StripeCardComponent) card: StripeCardComponent;

  cardOptions: ElementOptions = {
    iconStyle: 'solid',
    style: {
      base: {
        iconColor: '#8898AA',
        color: '#0f0f71',
        lineHeight: '15px',
        fontWeight: 300,
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSize: '15px',

        '::placeholder': {
          color: '#8898AA',
        },
      },
      invalid: {
        iconColor: '#e85746',
        color: '#e85746',
      }
    },
  };


  elementsOptions: ElementsOptions = {
    locale: 'en' // TODO : Make this flexible to show other languages
  };

  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private stripeService: StripeService,
    private restaurantservice: RestaurantService,
    private localStripeService:LocalStripeService,
    public modal: Modal,
    overlay: Overlay,
    vcRef: ViewContainerRef,
    private route: ActivatedRoute,
    private router: Router

  ) {


    route.data
      .subscribe( ( data : {restaurant:Restaurant  }) =>
        {
          this.restaurant = data.restaurant;
        }

      )



  }

  ngOnInit() {

    // console.log("Creating Credit Card On Init !");

    this.showCreditCardError = false;
    this.ccerror = '';

    this.form = this.fb.group({
      name: ['', [Validators.required,Validators.minLength(3)]],
      line1:['',[Validators.required,Validators.minLength(7)]],
      city:['',[Validators.required,Validators.minLength(3)]],
      email:['',[Validators.required, validateEmail]],

    });

    let thisRestaurantId = this.restaurant.$key;

    // console.log(thisRestaurantId);

    this.localStripeService.getBillingInfo(thisRestaurantId)
      .subscribe( (result) => {
           // console.log(result.id);
           this.customer_id = result.id;
    });

  };

  save(form) {

    // console.log(form);
    if (form.invalid){
      this.showErrors();
    } else {
      this.showCreditCardError = false;
      this.ccerror = '';
      this.stripeService
        .createSource(this.card.getCard(),{
          type: 'card',
          currency : 'usd', // TODO : Make this flexible to accept other currencies
          owner:{
            email : form.value.email,
            name : form.value.name,
            address : {
              city : form.value.city,
              country :'US', // TODO : Make this flexible to accept other countries
              line1 : form.value.line1,
              line2 : null,
              postal_code :  null,
              state : null
            }
            },

          })
        .subscribe(result => {
          if (!result.error) {
            // Use the token to create a charge or a customer
            // https://stripe.com/docs/charges
            // console.log("Showing Result ");
            // console.log(result);
            // console.log(result.source.id);
            this.addsourceToCustomer(this.customer_id,result.source.id);

          } else if (result.error) {
            // Error creating the token
            // console.log("There was an Error");
            this.showErrors();
            this.showCreditCardError = true;
            this.ccerror = result.error.message;
            // console.log(result.error.message);
          }
        });
    }
  }

  private addsourceToCustomer(customerid,sourceid){
    const sourceToCustomer$ = this.localStripeService.addSourcetoCustomer(customerid,sourceid);
    sourceToCustomer$
      .subscribe(() => {
          this.navigateToAccountingPAge();
        }
        ,err => this.messageIt('Error adding source ',err))


  }

  private navigateToAccountingPAge() {
    let restaurantId = this.restaurant.$key;

    let navigateRoute = './restaurants/'+ restaurantId

    navigateRoute = navigateRoute +'/edit';

    this.router.navigate([navigateRoute], {queryParams:{view:'Account'}});


  }

  messageIt(titleP:string,messageP:string){

    this.modal.alert()
      .size('lg')
      .showClose(true)
      .title(titleP)
      .body(messageP)
      .open();
  }

  isErrorVisible(field:string,error:string){

    return this.form.controls[field].dirty && this.form.controls[field].errors && this.form.controls[field].errors[error];

  }

  cancel() {
    let restaurantId = this.restaurant.$key;

    let navigateRoute = './restaurants/'+ restaurantId

    navigateRoute = navigateRoute +'/edit';

    this.router.navigate([navigateRoute], {queryParams:{view:'Account'}});
  }

  showErrors(){

    for (let element in this.form.controls){
      for(let element1 in  this.form.controls[element].errors){
        this.form.controls[element].markAsDirty();
      }
    }
  }

  reset() {
    this.form.reset();

  }

  isEmailValid():boolean{
    return !this.form.controls['email'].errors
  }

  showEmailErrors(){
    if (this.form.controls['email'].errors){
      this.form.controls['email'].markAsDirty();
    }

  }


}



// WEBPACK FOOTER //
// ./src/app/credit-card/credit-card-create/credit-card-create.component.ts